// var mySwiper = new Swiper("#swiper1", {
//   // direction: 'vertical', // 垂直切换选项
//   loop: true, // 循环模式选项
//   autoplay: {
//     delay: 8000,
//     stopOnLastSlide: false,
//     disableOnInteraction: true,
//   },
//   // 如果需要分页器
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
// });
(function () {
  $(document).ready(function () {
    if ($(".latest_box>li").length <= 10) {
      $(".page_box").hide();
    } else {
      $(".page_box").show();
    }
    var content = ".latest_box>li";
    var select = ".page_box";
    var goback = ".latest";
    load_article_page(1, 10, content, select, goback);
    function load_article_page(input_num, list_num, content, select, goback) {
      var total = $(content).length;
      var min_show = (input_num - 1) * list_num;
      var max_show = input_num * list_num - 1;
      var max_page = Math.ceil(total / list_num);
      $(select + " span").remove();
      $(select + " a.num").remove();
      $(select + " a.next").remove();
      $(select + " a.prev").remove();
      $(content).each(function (i) {
        console.log(i,min_show,max_show)
        if (i >= min_show && i <= max_show) {
          $(this).addClass("active");
        } else {
          $(this).removeClass("active");
        }
      });
      if (input_num == 1) {
        $(select + " input").before("<span class='prev'></span>");
      } else {
        $(select + " input").before("<a class='prev'></a>");
      }
      if (max_page <= 5) {
        show_nav(1, input_num, max_page, select);
      } else {
        if (input_num < 5) {
          show_nav(1, input_num, 5, select);
          $(select + " input").before("<span>...</span>");
          $(select + " input").before("<a class='num'>" + max_page + "</a>");
        } else {
          if (max_page - input_num <= 3) {
            $(select + " input").before("<a class='num'>1</a>");
            $(select + " input").before("<span>...</span>");
            show_nav(max_page - 4, input_num, max_page, select);
          } else {
            $(select + " input").before("<a class='num'>1</a>");
            $(select + " input").before("<span>...</span>");
            $(select + " input").before(
              "<a class='num'>" + (input_num - 1) + "</a>"
            );
            $(select + " input").before(
              "<span class='active'>" + input_num + "</span>"
            );
            $(select + " input").before(
              "<a class='num'>" + (input_num - -1) + "</a>"
            );
            $(select + " input").before("<span>...</span>");
            $(select + " input").before("<a class='num'>" + max_page + "</a>");
          }
        }
      }
      if (input_num == max_page) {
        $(select + " input").before("<span class='next'></span>");
      } else {
        $(select + " input").before("<a class='next'></a>");
      }
      $(select + " a").bind("click", function () {
        var top = $(goback).offset().top;
        var input_num = $(this).html();
        if ($(this).hasClass("next")) {
          var input_num = $(select + " span.active").html();
          input_num++;
          load_article_page(input_num, list_num, content, select, goback);
          $("body,html").animate({ scrollTop: top }, 40);
        } else {
          if ($(this).hasClass("prev")) {
            var input_num = $(select + " span.active").html() - 1;
            load_article_page(input_num, list_num, content, select, goback);
            $("body,html").animate({ scrollTop: top }, 40);
          } else {
            if ($(this).hasClass("go")) {
              var input_num = $("#select-input").val();
              if (isNaN(input_num) || input_num <= 0 || input_num > max_page) {
                return false;
              }
              load_article_page(input_num, list_num, content, select, goback);
              $("body,html").animate({ scrollTop: top }, 40);
            } else {
              load_article_page(input_num, list_num, content, select, goback);
              $("body,html").animate({ scrollTop: top }, 40);
            }
          }
        }
      });
    }
    function show_nav(first, input_num, max_page, select) {
      if($(window).width()>650){
        for (var i = first; i <= max_page; i++) {
          if (i == input_num) {
            $(select + " input").before("<span class='active'>" + i + "</span>");
          } else {
            $(select + " input").before("<a class='num'>" + i + "</a>");
          }
        }
      }else{
        for (var i = first; i <= max_page; i++) {
          if (i == input_num) {
            $(select + " input").before("<span class='active'>" + i + "</span>");
          }
        };
      }
    }
  });
})();